import { Component, OnInit, Input } from '@angular/core';

import { BukTicketGroup } from '../../models/buk-ticket.model';

@Component({
  selector: 'app-buk-ticket-group-summary-view',
  templateUrl: './buk-ticket-group-summary-view.component.html',
  styleUrls: ['./buk-ticket-group-summary-view.component.scss'],
})
export class BukTicketGroupSummaryViewComponent implements OnInit {
  @Input() group: BukTicketGroup;
  @Input() downloadURL: string;
  @Input() showContentsInfo = true;

  constructor() {}

  ngOnInit(): void {}
}
